/** Keyboard users jump past the navigation. Visible only when focused. */
export function SkipLink() {
  return (
    <a
      href="#main"
      className="bg-primary text-primary-foreground focus-visible:ring-ring sr-only inline-flex min-h-11 min-w-11 items-center rounded-lg px-4 focus:not-sr-only focus:absolute focus:top-2 focus:left-2 focus:z-50 focus-visible:ring-2 focus-visible:outline-none"
    >
      Skip to content
    </a>
  );
}
